import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core'
import { IonContent } from '@ionic/angular'
import { isColorDark } from 'src/utils/color'
import { FooterMode } from '../footer/footer.component'

@Component({
  selector: 'screen-container',
  templateUrl: './screen-container.component.html',
  styleUrls: ['./screen-container.component.scss'],
})
export class ScreenContainerComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) ionContent: IonContent | undefined

  constructor(private elementRef: ElementRef) {}

  @Input() disableScroll = false
  @Input() scrollEvents: boolean = false
  @Input() showAppBanner = true
  @Input() appBannerStyle: 'large' | 'small' = 'small'
  @Input() appLinkPath: string | undefined
  @Input() backgroundColor: string | undefined
  @Input() footerMode: FooterMode = 'light'
  @Input() hideFooter = false
  @Input() refreshEvent: boolean = false
  @Input() enableInfiniteScroll: boolean = false
  @Input() stickyAppInstallBanner: boolean = false
  @Output() ionScroll = new EventEmitter<Event>()
  @Output() ionContentComponent = new EventEmitter<IonContent>()
  @Output() ionRefresh = new EventEmitter<Event>()
  hideAppInstallBanner: boolean = false
  @Output() isBackgroundColorDark = new EventEmitter<boolean>()
  @Output() ionInfinite = new EventEmitter<Event>()
  isBackgroundColorDarkValue: boolean = false

  ngOnInit() {
    const ionContentEmitTimeout = setTimeout(() => {
      this.ionContentComponent.emit(this.ionContent)
      clearTimeout(ionContentEmitTimeout)
    }, 500)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('backgroundColor')) {
      this.setBackgroundColorDark()
    }
  }

  onIonInfinite(event) {
    this.ionInfinite.emit(event)
  }

  onScrollEvent(event) {
    if (this.scrollEvents) {
      this.ionScroll.emit(event)
    }
  }

  doRefresh(event) {
    if (this.scrollEvents) {
      this.ionRefresh.emit(event)
    }
  }

  private async setBackgroundColorDark(): Promise<void> {
    this.isBackgroundColorDarkValue = await this.calculateIsBackgroundColorDark()
    this.isBackgroundColorDark.emit(this.isBackgroundColorDarkValue)
  }

  private calculateIsBackgroundColorDark(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const calcTimeout = setTimeout(() => {
        const elems = this.elementRef.nativeElement.querySelectorAll('ion-content')
        const elem = elems[elems.length - 1]
        const shadowRoot = elem.shadowRoot
        if (!shadowRoot) {
          resolve(false)
          return
        }
        const backgroundContentElem = shadowRoot.querySelector('#background-content')
        if (!backgroundContentElem) {
          resolve(false)
          return
        }
        const computedStyle = window.getComputedStyle(backgroundContentElem)
        resolve(isColorDark(computedStyle.backgroundColor))
        clearTimeout(calcTimeout)
      })
    })
  }
}
